import { createRouter, createWebHistory } from 'vue-router';

import NotFound from './view/NotFound.vue';

const SelectResource = () => import('./view/SelectResource.vue');

const router = createRouter({
    history: createWebHistory(),
    routes: [
        { path: '/', redirect: '/request_resource' },
        { path: '/:page_id/request_resource/:campaign_key', component: SelectResource },
        { path: '/:notFound(.*)', component: NotFound }
    ]
});

router.beforeEach(function(to, _, next) {
    // if (to.meta.requiresAuth && !store.getters.isAuthenticated) {
    //     next('/auth');
    // } else if (to.meta.requiresUnauth && store.getters.isAuthenticated) {
    //     next('/coaches');
    // } else {
        next();
    // }
});

export default router;
